import { MaterialThemeProvider } from 'dg-web-shared/common/hooks/MaterialThemeProvider.tsx';
import { defaultOperatorMuiTheme } from 'operator-shared/theme/DefaultOperatorMuiTheme.ts';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';

export function ParkingCheckThemeProvider({
    children,
}: {
    children: React.ReactNode;
}) {
    const { language } = useLanguage();
    return (
        <MaterialThemeProvider
            theme={defaultOperatorMuiTheme}
            language={language}
        >
            {children}
        </MaterialThemeProvider>
    );
}
